<template>
  <base-spinner v-if="loading" />
  <div v-else class="weekly-view">
    <div class="header d-flex align-items-center p-0">
      <div
        v-for="(date, index) in range"
        :key="index"
        :class="['header-block', { 'present-day': isPresentDay(date) ? true : false }]"
      >
        <div class="day p-2">
          {{ formatRangeDay(date) }}
        </div>
        <div class="slots d-flex justify-content-center"></div>
      </div>
    </div>
    <div class="events d-flex align-items-center">
      <div
        v-for="(d_range, d_range_index) in range"
        :key="d_range_index"
        :class="[
          'event-day',
          {
            'present-day-event-day': isPresentDay(d_range) ? true : false,
          },
        ]"
      >
        <div v-for="(t_range, t_range_index) in time_range" :key="t_range_index" class="event">
          <div
            v-for="(event, event_index) in events.filter((e) => findEvent(e, t_range, d_range))"
            :key="event_index"
            class="contain-block"
          >
            <div
              class="block"
              :style="getBlockStyle(event)"
              @click.stop="$emit('eventClick', event)"
            >
              <div class="d-flex align-items-center">
                <div class="event_id d-flex"><span>#</span>{{ event.trip_id }}</div>

                <!-- <div class="dot"></div>
                <div class="journey">
                  {{ event.number_of_trips.toString().padStart(2, 0) }} Journeys
                </div> -->
              </div>
              <div class="name">{{ event.client }}</div>
              <div class="name">
                {{
                  isLangRtl
                    ? formatDate(event?.date?.toString().slice(0, 10), 'Do MMMM')
                    : event?.date?.toString().slice(0, 10)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NewReservationService from '@/services/new-reservation.service'

export default {
  props: ['selected_date', 'events', 'event_types'],
  emits: ['eventClick'],
  data() {
    return {
      range: [],
      time_range: [],
      loading: false,
    }
  },
  methods: {
    getBlockStyle(event) {
      const rec = this.event_types?.find((each) => each.value === event.type)
      return rec ? `background: ${rec.background};border: ${rec.border};` : null
    },
    isPresentDay(day) {
      return moment(day).isSame(moment(), 'day')
    },
    async getRange() {
      const now = moment(this.selected_date)
      let temp = []
      this.loading = true

      for (let i = 0; i < 7; i++) {
        const day = now.clone().weekday(i)
        temp.push(day)
      }

      this.range = temp
      this.loading = false
    },
    getTimeRange() {
      let temp = []

      for (let i = 1; i < 25; i++) {
        temp.push(
          moment()
            .set('hour', 6 + i)
            .set('minute', 0)
            .set('seconds', 0)
        )
      }
      this.time_range = temp
    },
    findEvent(event, time, date) {
      let date1 = event.start_time,
        date2 = date.set('hour', time.get('hour')).set('minute', 0).set('seconds', 0)

      return moment(date1).diff(date2, 'minutes') === 0
    },
    findSameDayEvent(event, date) {
      return moment(event.date).isSame(moment(date), 'day')
    },
    formatRangeDay(date) {
      return this.isLangRtl
        ? this.formatDate(date, 'ddd DD')
        : moment(date).locale('en').format('ddd DD')
    },
  },
  watch: {
    selected_date() {
      this.getRange()
    },
  },
  mounted() {
    this.getRange()
    this.getTimeRange()
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.weekly-view {
  // min-width: 1056px;
  overflow: auto;
}
.header {
  .header-block {
    // flex: 1 1 0px;
    padding: 0.5rem;
    text-align: center;
    background: var(--color-11);
    color: var(--color-09);
    border-width: 0px 1px;
    border-style: solid;
    border-color: var(--color-01);

    .day {
      font-weight: 700;
      font-size: 14px;
      width: 187px;
    }
    .slots {
      font-weight: 400;
      font-size: 16px;
      width: 187px;
    }
    &:first-child {
      border-inline-start: 1px solid var(--color-15);
    }
    &:last-child {
      border-inline-end: 1px solid var(--color-15);
    }
  }
  .present-day {
    background: var(--color-09);
    color: var(--color-01);
    border-radius: 5px;
  }
}
.events {
  .event-day {
    // flex: 1 1 0px;

    .contain-block {
      height: 100px;
      margin: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .event {
      height: 100px;
      width: 205px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      border: 1px solid var(--color-15);
      border-top: 0px;
      border-inline-end: 0px;

      .block {
        width: 100%;
        overflow: auto;
        cursor: pointer;
        padding: 0.75rem;
        border-radius: 8px;
        .event_id {
          font-size: 12px;
          color: var(--color-17);
        }
        .dot {
          margin: 0rem 0.25rem;
          background: var(--color-17);
          border-radius: 50%;
          height: 5px;
          width: 5px;
        }

        .journey {
          color: var(--color-17);
          font-size: 12px;
        }

        .name {
          font-weight: 700;
          font-size: 14px;
          color: var(--color-17);
        }
      }
    }

    &:last-child {
      .event {
        border-inline-end: 1px solid var(--color-15);
      }
    }
  }
  .present-day-event-day {
    background: var(--color-64);
  }
}
</style>
